import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { isPortrait } from '../../utils/size';

const SponsoredContainer = styled.div`
    align-items: center;
    font-size: 10px;
    color: #6c6c6c;
    border-style: solid;
    border-width: 1px;
    border-color: #dbdbdb;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;
    padding: 0 16px 3px;
    position: absolute;
    width: auto;
    top: -1px;
    left: ${props => (props.isVisual && !isPortrait() ? 35 : 50)}%;
    transform: translateX(-50%);
    text-align: center;
    white-space: nowrap;

    @media (max-width: 30em) {
        font-size: 8px;
        pading: 0 6px 2px;
    }
`;

export const SponsoredTag = props => (
    <SponsoredContainer isVisual={props.isVisual}>
        {props.sponsoredText}
    </SponsoredContainer>
);

SponsoredTag.propTypes = {
    sponsoredText: PropTypes.string,
    isVisual: PropTypes.bool
};
